// extracted by mini-css-extract-plugin
export default {"root":"LicenseListDialogContent_root__P+6PI","section":"LicenseListDialogContent_section__fv0CV"};